/**
 * Données des projets/portfolio - Olney Tech Solutions
 * Framework BAB (Before/After/Bridge) pour chaque projet
 */

export const projects = [
  {
    id: 1,
    slug: 'ecommerce-biocosmetiques-lille',
    title: "Site E-commerce BioCosmétiques Lille",
    category: "E-commerce",
    client: "PME Cosmétiques Bio",
    clientSize: "3 employés",
    location: "Lille",
    year: "2025",
    duration: "4 semaines",
    thumbnail: "/portfolio/1-ecommerce/hero.png",
    images: [
      "/portfolio/1-ecommerce/hero.png",
      "/portfolio/1-ecommerce/preview-1.png",
      "/portfolio/1-ecommerce/preview-2.png"
    ],
    technologies: ["React", "Shopify", "Stripe", "Tailwind CSS"],

    // Framework BAB
    before: {
      situation: "Site vitrine statique peu visité. Ventes uniquement en boutique physique, clientèle limitée à 15km autour.",
      pain: "CA mensuel plafonné à 2 000€, aucune visibilité en ligne, dépendance totale au trafic physique.",
      metrics: ["CA mensuel: 2 000€", "Visibilité: locale uniquement", "Ventes en ligne: 0€"]
    },
    after: {
      situation: "Boutique en ligne performante avec livraison nationale, présence forte sur Google.",
      gain: "CA mensuel passé de 2 000€ à 8 000€ (+300%) en 4 mois, nouvelles clientes dans toute la France.",
      metrics: ["CA mensuel: 8 000€", "Taux conversion: 45%", "Temps chargement: < 2s"]
    },
    bridge: {
      approach: "Refonte complète avec focus SEO local, optimisation fiches produits, tunnel de conversion simplifié.",
      steps: [
        "Audit de l'existant et analyse de la concurrence",
        "Design e-commerce moderne et responsive",
        "Migration et optimisation du catalogue produits",
        "Intégration Stripe et livraison Colissimo",
        "Formation de l'équipe sur la gestion Shopify"
      ]
    },

    results: [
      { metric: "+300%", label: "CA mensuel", detail: "2 000€ → 8 000€" },
      { metric: "45%", label: "Taux de conversion", detail: "Tunnel optimisé" },
      { metric: "< 2s", label: "Temps de chargement", detail: "Performance A+" }
    ],

    testimonial: {
      quote: "Notre CA a quadruplé en 4 mois. L'accompagnement d'Antho sur le SEO local et l'optimisation des fiches produits a fait toute la différence. On reçoit maintenant des commandes de toute la France !",
      author: "Marie Dubois",
      role: "Gérante",
      avatar: null
    },

    metaTitle: "Case Study E-commerce BioCosmétiques | +300% CA | Olney Tech",
    metaDescription: "Comment nous avons multiplié par 4 le CA d'une boutique de cosmétiques bio à Lille grâce à un site e-commerce optimisé. Étude de cas complète."
  },
  {
    id: 2,
    slug: 'infrastructure-cloud-cabinet-comptable',
    title: "Infrastructure Cloud - Cabinet Comptable",
    category: "Cloud Infrastructure",
    client: "Cabinet comptable",
    clientSize: "12 employés",
    location: "Métropole lilloise",
    year: "2024",
    duration: "6 semaines",
    thumbnail: "/portfolio/4-dashboard-cloud/hero.png",
    images: [
      "/portfolio/4-dashboard-cloud/hero.png",
      "/portfolio/4-dashboard-cloud/preview-1.png",
      "/portfolio/4-dashboard-cloud/preview-2.png"
    ],
    technologies: ["AWS", "Docker", "PostgreSQL", "Terraform", "Grafana"],

    before: {
      situation: "Serveurs physiques vieillissants installés en 2015, pannes fréquentes perturbant le travail.",
      pain: "2-3 pannes par mois, sauvegardes manuelles aléatoires, risque de perte de données clients.",
      metrics: ["Pannes: 2-3/mois", "Coûts IT: 2 500€/mois", "Sauvegardes: manuelles"]
    },
    after: {
      situation: "Infrastructure cloud haute disponibilité avec redondance et sauvegardes automatiques.",
      gain: "0 panne en 12 mois, économie de 12 000€/an, sérénité totale pour l'équipe.",
      metrics: ["Pannes: 0 en 12 mois", "Coûts IT: 1 500€/mois", "Uptime: 99.9%"]
    },
    bridge: {
      approach: "Migration progressive sur AWS avec zéro interruption de service.",
      steps: [
        "Audit complet de l'infrastructure existante",
        "Architecture cloud sur AWS (EC2, RDS, S3)",
        "Migration des données avec validation",
        "Mise en place monitoring Grafana 24/7",
        "Formation des équipes et documentation"
      ]
    },

    results: [
      { metric: "-40%", label: "Coûts IT", detail: "2 500€ → 1 500€/mois" },
      { metric: "99.9%", label: "Uptime garanti", detail: "SLA contractuel" },
      { metric: "0", label: "Pannes en 12 mois", detail: "vs 30+ avant" }
    ],

    testimonial: {
      quote: "Plus aucune panne depuis la migration. Nous avons économisé 12 000€ la première année tout en gagnant en fiabilité. Le monitoring 24/7 nous rassure complètement.",
      author: "Jean Martin",
      role: "Directeur IT",
      avatar: null
    },

    metaTitle: "Case Study Cloud Cabinet Comptable | -40% Coûts | Olney Tech",
    metaDescription: "Migration cloud AWS pour cabinet comptable : -40% de coûts, 0 panne en 12 mois. Découvrez comment nous avons transformé leur infrastructure IT."
  },
  {
    id: 3,
    slug: 'application-intranet-pme-industrielle',
    title: "Application Web Intranet - PME Industrielle",
    category: "Développement Web",
    client: "PME Industrielle",
    clientSize: "45 employés",
    location: "Hauts-de-France",
    year: "2025",
    duration: "8 semaines",
    thumbnail: "/portfolio/3-intranet-pme/hero.png",
    images: [
      "/portfolio/3-intranet-pme/hero.png",
      "/portfolio/3-intranet-pme/preview-1.png",
      "/portfolio/3-intranet-pme/preview-2.png"
    ],
    technologies: ["React", "Node.js", "MongoDB", "Express", "Socket.io"],

    before: {
      situation: "Gestion sur Excel et papier, processus manuels chronophages.",
      pain: "Erreurs fréquentes de saisie, temps de traitement long (2-3 jours par commande), pas de visibilité temps réel.",
      metrics: ["Traitement: 2-3 jours/commande", "Erreurs: fréquentes", "Admin: 8h/semaine"]
    },
    after: {
      situation: "Application web centralisée avec saisie automatisée et tableau de bord temps réel.",
      gain: "Traitement instantané, 90% de réduction des erreurs, 15h/semaine économisées.",
      metrics: ["Traitement: instantané", "Erreurs: -90%", "Admin: 30min/semaine"]
    },
    bridge: {
      approach: "Développement d'une interface intuitive adaptée aux besoins spécifiques de l'entreprise.",
      steps: [
        "Analyse des processus existants avec les équipes",
        "Design UX centré utilisateur",
        "Développement itératif avec feedback",
        "Import automatique des données Excel historiques",
        "Formation sur 2 jours + support 3 mois"
      ]
    },

    results: [
      { metric: "15h/sem", label: "Temps gagné", detail: "Pour l'équipe admin" },
      { metric: "-90%", label: "Réduction erreurs", detail: "Validation automatique" },
      { metric: "8 sem", label: "ROI atteint", detail: "Retour sur investissement" }
    ],

    testimonial: {
      quote: "L'équipe administrative a gagné 15h par semaine. Le retour sur investissement a été atteint en 2 mois. On se demande comment on faisait avant !",
      author: "Sophie Durand",
      role: "Responsable Administrative",
      avatar: null
    },

    metaTitle: "Case Study Intranet PME | -90% Erreurs | Olney Tech",
    metaDescription: "Application intranet sur mesure pour PME industrielle : 15h/semaine économisées, 90% d'erreurs en moins. Étude de cas développement web."
  },
  {
    id: 4,
    slug: 'chatbot-ia-service-client-ecommerce',
    title: "Chatbot IA - Service Client E-commerce",
    category: "Intelligence Artificielle",
    client: "E-commerce Mode",
    clientSize: "8 employés",
    location: "France",
    year: "2025",
    duration: "5 semaines",
    thumbnail: "/portfolio/2-chatbot-ia/hero.png",
    images: [
      "/portfolio/2-chatbot-ia/hero.png",
      "/portfolio/2-chatbot-ia/preview-1.png",
      "/portfolio/2-chatbot-ia/preview-2.png"
    ],
    technologies: ["Claude AI", "Python", "React", "FastAPI", "PostgreSQL"],

    before: {
      situation: "Service client débordé par les demandes répétitives.",
      pain: "Temps de réponse moyen 12h, 80% des questions identiques, satisfaction client en berne.",
      metrics: ["Temps réponse: 12h", "Questions répétitives: 80%", "Satisfaction: 65%"]
    },
    after: {
      situation: "Chatbot IA gérant 75% des demandes instantanément, équipe focalisée sur les cas complexes.",
      gain: "Temps de réponse < 1min, satisfaction à 92%, équipe libérée pour le conseil.",
      metrics: ["Temps réponse: < 1min", "Automatisation: 75%", "Satisfaction: 92%"]
    },
    bridge: {
      approach: "Analyse des conversations clients pour entraîner une IA sur mesure.",
      steps: [
        "Analyse de 2000+ conversations clients",
        "Entraînement IA sur FAQ spécifiques",
        "Design interface chat intuitive",
        "Intégration progressive avec escalade humaine",
        "Monitoring et amélioration continue"
      ]
    },

    results: [
      { metric: "75%", label: "Demandes automatisées", detail: "Traitement instantané" },
      { metric: "92%", label: "Satisfaction client", detail: "vs 65% avant" },
      { metric: "< 1min", label: "Temps de réponse", detail: "24/7" }
    ],

    testimonial: {
      quote: "Le chatbot gère 3 clients sur 4. Notre équipe peut enfin se concentrer sur les demandes complexes. Game changer pour notre service client !",
      author: "Thomas Leroy",
      role: "Responsable Client",
      avatar: null
    },

    metaTitle: "Case Study Chatbot IA E-commerce | 75% Automatisation | Olney Tech",
    metaDescription: "Chatbot IA pour e-commerce : 75% des demandes automatisées, satisfaction client à 92%. Découvrez notre solution IA service client."
  },
  {
    id: 5,
    slug: 'audit-cybersecurite-startup-fintech',
    title: "Audit Cybersécurité - Startup FinTech",
    category: "Cybersécurité",
    client: "Startup FinTech",
    clientSize: "15 employés",
    location: "Lille",
    year: "2024",
    duration: "3 semaines",
    thumbnail: "/portfolio/5-audit-cybersecurite/hero.png",
    images: [
      "/portfolio/5-audit-cybersecurite/hero.png",
      "/portfolio/5-audit-cybersecurite/preview-1.png",
      "/portfolio/5-audit-cybersecurite/preview-2.png"
    ],
    technologies: ["Penetration Testing", "OWASP", "Burp Suite", "Nessus", "Metasploit"],

    before: {
      situation: "Aucun audit de sécurité depuis le lancement, pratiques de sécurité basiques.",
      pain: "Mots de passe faibles, données sensibles non chiffrées, 12 vulnérabilités critiques identifiées.",
      metrics: ["Audits: 0", "Vulnérabilités critiques: 12", "Score sécurité: 45/100"]
    },
    after: {
      situation: "Infrastructure sécurisée avec chiffrement, 2FA et conformité RGPD.",
      gain: "100% des vulnérabilités critiques corrigées, score sécurité à 95/100.",
      metrics: ["Vulnérabilités critiques: 0", "Score sécurité: 95/100", "Conformité: RGPD"]
    },
    bridge: {
      approach: "Audit complet avec tests d'intrusion et accompagnement sur les corrections.",
      steps: [
        "Tests de pénétration internes et externes",
        "Analyse des vulnérabilités OWASP Top 10",
        "Rapport détaillé avec priorisation",
        "Accompagnement correction faille par faille",
        "Mise en place monitoring sécurité"
      ]
    },

    results: [
      { metric: "12 → 0", label: "Vulnérabilités critiques", detail: "100% corrigées" },
      { metric: "95/100", label: "Score de sécurité", detail: "vs 45 avant" },
      { metric: "100%", label: "Conformité RGPD", detail: "Attestation fournie" }
    ],

    testimonial: {
      quote: "L'audit a révélé 12 failles critiques dont nous n'avions aucune idée. Tout a été corrigé en 3 semaines. On dort beaucoup mieux maintenant !",
      author: "Alexandre Blanc",
      role: "CTO",
      avatar: null
    },

    metaTitle: "Case Study Audit Cybersécurité FinTech | 12 Failles Corrigées | Olney Tech",
    metaDescription: "Audit cybersécurité pour startup FinTech : 12 vulnérabilités critiques corrigées, score sécurité 95/100. Expert sécurité informatique Lille."
  },
  {
    id: 6,
    slug: 'application-mobile-artisans-batiment',
    title: "Application Mobile - Artisans du Bâtiment",
    category: "Application Mobile",
    client: "Artisan plombier indépendant",
    clientSize: "Indépendant",
    location: "Hauts-de-France",
    year: "2025",
    duration: "6 semaines",
    thumbnail: "/portfolio/6-app-mobile-artisans/hero.png",
    images: [
      "/portfolio/6-app-mobile-artisans/hero.png",
      "/portfolio/6-app-mobile-artisans/preview-1.png",
      "/portfolio/6-app-mobile-artisans/preview-2.png"
    ],
    technologies: ["React Native", "Expo", "Firebase", "Stripe Connect", "PDF Generation"],

    before: {
      situation: "Devis papier, gestion manuelle, paiements par chèque uniquement.",
      pain: "15% des devis jamais envoyés, 8h/semaine de travail administratif, délai paiement 45 jours.",
      metrics: ["Admin: 8h/semaine", "Délai devis: 2-3 jours", "Délai paiement: 45 jours"]
    },
    after: {
      situation: "App mobile tout-en-un : devis, signature, paiement depuis le chantier.",
      gain: "Temps admin réduit de 94%, devis envoyés en 2 minutes, paiement sous 27 jours.",
      metrics: ["Admin: 30min/semaine", "Délai devis: 2 minutes", "Délai paiement: 27 jours"]
    },
    bridge: {
      approach: "App mobile-first optimisée pour usage chantier (gants, soleil).",
      steps: [
        "Design adapté aux conditions terrain",
        "Signature électronique tactile",
        "Génération PDF automatique",
        "Intégration paiements Stripe",
        "Notifications push pour relances"
      ]
    },

    results: [
      { metric: "-94%", label: "Temps admin", detail: "8h → 30min/semaine" },
      { metric: "-97%", label: "Temps envoi devis", detail: "60min → 2min" },
      { metric: "+25%", label: "Taux conversion devis", detail: "48% → 60%" }
    ],

    testimonial: {
      quote: "L'app, c'est devenu mon bras droit. Je fais mes devis direct sur place en 2 minutes, le client signe, il reçoit le PDF dans la minute. J'ai récupéré 7 heures par semaine !",
      author: "Marc Durand",
      role: "Plombier indépendant",
      avatar: null
    },

    metaTitle: "Case Study App Mobile Artisans | -94% Temps Admin | Olney Tech",
    metaDescription: "Application mobile pour artisans : devis en 2 minutes, signature électronique, paiement intégré. ROI 211% sur 12 mois."
  }
];

export const getProjectBySlug = (slug) => projects.find(p => p.slug === slug);
export const getProjectById = (id) => projects.find(p => p.id === id);
export const getProjectsByCategory = (category) => projects.filter(p => p.category === category);
